"use client";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ReactNode } from "react";
import { parseMutationErrorMessage } from "~/graphql-client";
import { STRIPE_API_VERSION, STRIPE_OPTIONS } from "~/constants";
import * as Sentry from "@sentry/nextjs";

export function StripeProvider(props: {
  children: ReactNode;
  stripePublishableKey: string;
}): React.ReactElement {
  // no await
  const stripePromise = loadStripe(props.stripePublishableKey, {
    apiVersion: STRIPE_API_VERSION,
  }).catch((error) => {
    const errorMessage = parseMutationErrorMessage(error.message);
    const message = `Error loading payment config: ${
      errorMessage || error.message
    }`;
    console.error(message);
    Sentry.captureException(error);
    throw new Error(message);
  });

  return (
    <Elements stripe={stripePromise} options={STRIPE_OPTIONS}>
      {props.children}
    </Elements>
  );
}
